/** EmptyState.tsx — "nothing here" block with an optional action. */

import type { HTMLAttributes, ReactNode } from 'react';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string;
  action?: ReactNode;
}

export const EmptyState = ({
  title,
  action = undefined,
  className = '',
  ...rest
}: EmptyStateProps) => (
  <div
    // eslint-disable-next-line react/jsx-props-no-spreading -- primitive forwards native HTML attributes (data-testid, aria-*) to the root element
    {...rest}
    role="status"
    className={`flex flex-col items-start gap-3 rounded-xl bg-surface-2 p-4 ${className}`.trim()}
  >
    <p className="text-body text-ink-2">{title}</p>
    {action}
  </div>
);
